module.exports = __webpack_public_path__ + "img/icon_arrow_right.9676966e.svg";